import type { ReactNode } from 'react'
import { Skeleton } from '@systemeio/components'

const UserSettingsSkeleton = (): ReactNode => (
  <div className="flex h-fit w-full flex-col gap-2 overflow-x-hidden rounded-md bg-bg-primary md:gap-5">
    <div className="h-16 bg-bg-accent/10 p-5">
      <Skeleton className="h-6 w-full rounded-sm" />
    </div>
    <div className="flex flex-col gap-7 px-5 pt-5 pb-7 md:gap-10 md:pb-10">
      <div className="flex flex-col justify-between gap-7 *:flex-1 md:h-16.5 md:flex-row md:gap-10">
        <Skeleton className="my-3 h-5 rounded-sm py-2.5 md:py-0" />
        <div />
      </div>
      <div className="flex flex-col justify-between gap-7 *:flex-1 md:h-16.5 md:flex-row md:gap-10">
        <Skeleton className="my-3 h-5 rounded-sm py-2.5 md:py-0" />
        <Skeleton className="my-3 h-5 rounded-sm py-2.5 md:py-0" />
      </div>
      <div className="flex flex-col justify-between gap-7 *:flex-1 md:h-16.5 md:flex-row md:gap-10">
        <Skeleton className="my-3 h-5 rounded-sm py-2.5 md:py-0" />
        <Skeleton className="my-3 h-5 rounded-sm py-2.5 md:py-0" />
      </div>
      <div className="flex flex-col justify-between gap-7 *:flex-1 md:h-16.5 md:flex-row md:gap-10">
        <Skeleton className="my-3 h-5 rounded-sm py-2.5 md:py-0" />
        <Skeleton className="my-3 h-5 rounded-sm py-2.5 md:py-0" />
      </div>
      <div className="flex flex-col justify-between gap-7 *:flex-1 md:h-16.5 md:flex-row md:gap-10">
        <Skeleton className="my-3 h-5 rounded-sm py-2.5 md:py-0" />
        <Skeleton className="my-3 h-5 rounded-sm py-2.5 md:py-0" />
      </div>
      <div className="flex flex-col justify-between gap-7 *:flex-1 md:h-11 md:flex-row md:gap-10">
        <Skeleton className="my-2 h-5 rounded-sm py-1" />
      </div>
    </div>
  </div>
)

export default UserSettingsSkeleton
